export default {
  nav: {
    home: "Accueil",
    engines: "Moteurs",
    transmissions: "Boîtes de vitesses",
    bodyParts: "Pièces de carrosserie",
    testimonials: "Témoignages",
    contact: "Contact",
    getQuote: "Obtenir un devis",
    menu: "Ouvrir le menu",
  },
  banner: {
    text: "GROSSES SOLDES — Jusqu'à 30% de REMISE sur une sélection de moteurs, boîtes de vitesses et pièces de carrosserie. Livraison disponible dans toute l'Australie.",
  },
  hero: {
    badge: "De confiance depuis 2005",
    title1: "Moteurs d'occasion de qualité et",
    titleHighlight: "Boîtes de vitesses",
    desc: "{{siteName}} est votre guichet unique pour les pièces détachées d'occasion, neuves et aftermarket à Darwin. Spécialistes des pick-up et SUV les plus populaires du marché australien.",
    contact: "Contact",
    browse: "Parcourir les moteurs",
  },
  about: {
    f1title: "Entreprise familiale",
    f1text: "{{siteName}} est une entreprise familiale de Darwin fondée sur la confiance, le travail acharné et un véritable souci de chaque client.",
    f2title: "Réputation",
    f2text: "Nous jouissons d'une solide réputation fondée sur l'intégrité, l'équité et la maîtrise technique des pièces d'occasion, neuves et aftermarket.",
    f3title: "Ce que nous faisons",
    f3text: "Nous sommes votre guichet unique pour les pièces détachées d'occasion, neuves et aftermarket, soutenus par un atelier spécialisé de service et de réparation.",
    f4title: "Hautement qualifiés",
    f4text: "Nos techniciens expérimentés utilisent les derniers outils de diagnostic et scanners pour vous éviter des coûts de réparation inutiles.",
    stockLabel: "Ce que nous proposons",
    modelsTitle: "Modèles populaires que nous couvrons",
    modelsDesc: "Nous nous concentrons sur les pick-up et SUV australiens les plus vendus pour vous fournir la bonne pièce, rapidement.",
  },
  why: {
    promise: "Notre promesse",
    title: "Pourquoi nous choisir",
    w1title: "Qualité",
    w1text: "La tranquillité d'esprit de savoir que vous avez reçu une pièce et un service de haute qualité, à chaque fois.",
    w2title: "Économies",
    w2text: "Gardez plus d'argent en poche grâce à nos excellentes remises sur toutes les pièces, neuves et d'occasion.",
    w3title: "Garantie",
    w3text: "Les pièces neuves bénéficient de 12 mois de garantie et les pièces d'occasion de 3 mois.",
    w4title: "Livraison",
    w4text: "Les petits articles sont expédiés en 24h, les plus volumineux sous 1 à 3 jours dans toute l'Australie.",
    missionTitle: "Notre mission",
    missionText: "Vous offrir, à vous, nos clients et notre communauté, un service client de classe mondiale. Nous visons la plus haute qualité dans tout ce que nous faisons pour mieux vous servir — à travers nos quatre piliers : Famille, Détermination, Innovation & Qualité.",
    valuesTitle: "Nos valeurs",
    v1label: "Famille",
    v1text: "Nous sommes une seule équipe qui se soucie de nos clients, de nos collaborateurs et de nos fournisseurs.",
    v2label: "Détermination",
    v2text: "Nous visons le meilleur dans ce que nous faisons, avec une véritable passion pour la réussite.",
    v3label: "Innovation",
    v3text: "Nous sortons des sentiers battus et travaillons dur pour nous améliorer en continu.",
    v4label: "Qualité",
    v4text: "Nous nous efforçons de bien faire du premier coup, à chaque fois.",
    t1text: "Service génial. Réparation effectuée le jour même avec une communication constante — le tout à un excellent prix !",
    t1name: "Nico A.",
    t1loc: "Darwin",
    t2text: "J'ai trouvé exactement le moteur qu'il me fallait pour mon HiLux. Sympathiques, honnêtes et très compétents sur les pick-up australiens. Je recommande vivement.",
    t2name: "Chris N.",
    t2loc: "Palmerston",
    t3text: "Très serviables, justes et honnêtes, avec des pièces d'occasion de qualité pour tous les modèles populaires. Un grand bravo !",
    t3name: "Stephen C.",
    t3loc: "Darwin",
    t4text: "Arrivé avec des problèmes inconnus, et ces gars m'ont remis en route rapidement. Service fantastique.",
    t4name: "Armand D.",
    t4loc: "Katherine",
  },
  brand: {
    strip: "Pièces pour toutes les grandes marques",
  },
  cta: {
    title: "Vous cherchez une pièce ?",
    desc: "Dites-nous ce dont vous avez besoin et notre équipe la trouvera pour vous. Nous livrons dans toute l'Australie depuis notre atelier de Winnellie, Darwin.",
    request: "Demander un devis",
  },
  footer: {
    brandDesc: "La source de confiance de Darwin pour des moteurs d'occasion, boîtes de vitesses et pièces de carrosserie de qualité. Entreprise familiale axée sur les pick-up et SUV australiens les plus populaires.",
    quickLinks: "Liens rapides",
    company: "Entreprise",
    getInTouch: "Contactez-nous",
    monFri: "Lun - Ven : 8h00 - 17h00",
    copyright: "© Copyright {{year}} {{siteName}}. Tous droits réservés.",
    disclaimer: "{{siteName}} est un spécialiste indépendant des pièces et services.",
  },
  page: {
    enginesSubtitle: "Moteurs d'occasion, neufs et reconditionnés de qualité pour toutes les marques et modèles – européens, japonais et américains. Chaque moteur est inspecté, scellé et fourni avec garantie.",
    transmissionsSubtitle: "Boîtes de vitesses automatiques et manuelles, d'occasion et neuves, pour toutes les marques et modèles – européens, japonais et américains. Chaque boîte est inspectée, testée et fournie avec garantie.",
    bodyPartsSubtitle: "Panneaux de carrosserie, pare-chocs, rétroviseurs, feux et garnitures, d'occasion et aftermarket, pour toutes les marques et modèles. Panneaux droits, prix compétitifs avec garantie.",
  },
  grid: {
    ourStock: "Notre stock",
    itemsInStock: "{{count}} articles en stock",
    shipping: "Livraison dans toute l'Australie",
    price: "Prix",
    enquire: "Demander maintenant",
    searchPlaceholder: "Rechercher par marque, modèle ou nom de pièce...",
    allMakes: "Toutes les marques",
    allModels: "Tous les modèles",
    noResults: "Aucune pièce ne correspond. Essayez une autre marque ou un autre modèle.",
    clearFilters: "Effacer les filtres",
  },
  availability: {
    badge: "Mise à jour du stock",
    title: "Occasion & Neuf {{category}}",
    text: "Nous avons des moteurs, boîtes de vitesses et pièces de carrosserie pour toutes les marques et modèles. Nous proposons une large gamme de moteurs, boîtes de vitesses et pièces de carrosserie pour les véhicules européens, japonais, canadiens et américains. Toutes les pièces sont inspectées et répondent aux exigences de qualité auxquelles elles sont soumises ; chaque article est scellé et porte une marque spéciale. Toutes les pièces d'occasion bénéficient d'une garantie de qualité à long terme. Si vous avez le moindre doute sur le choix de votre moteur, boîte de vitesses ou pièce de carrosserie, contactez notre équipe – nous serons ravis de répondre à vos questions et de vous conseiller de manière complète. {{siteName}} – une recherche pratique de pièces d'occasion & neuves, avec une livraison rapide sous 1 à 3 jours ouvrables après réception du paiement.",
    cta: "Contact",
  },
  request: {
    badge: "Pièce introuvable ?",
    title: "Vous ne trouvez pas la pièce qu'il vous faut ?",
    text: "{{siteName}} déniche chaque semaine des moteurs, boîtes de vitesses et pièces de carrosserie difficiles à trouver. Indiquez-nous la marque, le modèle et l'année — si elle n'est pas en stock aujourd'hui, notre équipe la trouvera pour vous et vous répondra rapidement.",
    cta: "Demander une pièce",
  },
  partsWeSource: {
    badge: "Commande spéciale",
    title: "Pièces que nous recherchons",
    desc: "Vous ne voyez pas ce que vous cherchez ? {{siteName}} déniche chaque semaine des pièces difficiles à trouver — des calculateurs et boîtiers électroniques rares aux pièces uniques que personne d'autre ne stocke.",
    ecuTitle: "Calculateurs & boîtiers de commande",
    ecuText: "Modules de commande moteur, boîte et carrosserie, programmés et testés sur votre véhicule.",
    computerBoxTitle: "Boîtiers électroniques",
    computerBoxText: "Boîtiers de gestion moteur et modules câblés pour pick-up, SUV et plus encore.",
    hardToFindTitle: "Pièces difficiles à trouver",
    hardToFindText: "Garnitures rares, panneaux arrêtés et pièces spéciales trouvées via notre réseau national.",
    cta: "Demander une pièce",
  },
  contact: {
    badge: "Entrer en contact",
    title: "Contact",
    desc: "Une pièce en tête ? Envoyez-nous une demande et notre équipe vous répondra rapidement. Nous livrons dans toute l'Australie depuis Winnellie, Darwin NT 0820.",
    sendEnquiry: "Envoyer une demande",
    formDesc: "Remplissez le formulaire et nous vous recontacterons rapidement.",
    prefill: "Nous avons pré-rempli la pièce qui vous intéresse. Ajoutez simplement vos coordonnées et d'éventuelles notes ci-dessous.",
    name: "Nom",
    namePlaceholder: "Votre nom complet",
    email: "E-mail",
    emailPlaceholder: "vous@email.fr",
    phone: "Téléphone",
    phonePlaceholder: "+61 4xx xxx xxx",
    subject: "Objet",
    subjectPlaceholder: "Choisissez un sujet",
    subjectEngine: "Demande de moteur",
    subjectTransmission: "Demande de boîte de vitesses",
    subjectBody: "Demande de pièce de carrosserie",
    subjectGeneral: "Demande générale",
    subjectSpecialOrder: "Commande spéciale / Demande de pièce",
    part: "Pièce / article demandé",
    partPlaceholder: "ex. Moteur – Toyota HiLux 2018",
    vehicle: "Véhicule (Marque, Modèle & Année)",
    vehiclePlaceholder: "ex. Toyota HiLux 2018",
    notes: "Notes",
    notesPlaceholder: "Dites-nous quelle pièce vous recherchez...",
    maxChars: "Max 500 caractères",
    partPhoto: "Photo de la pièce (facultatif)",
    partPhotoHint: "JPG, PNG ou WebP, jusqu'à 8 Mo. Nous aide à identifier la pièce exacte plus rapidement.",
    choosePhoto: "Choisir une photo",
    removePhoto: "Supprimer la photo",
    photoInvalid: "Veuillez choisir un fichier image (JPG, PNG ou WebP).",
    photoTooLarge: "Cette image est trop volumineuse. Veuillez en choisir une de moins de 8 Mo.",
    success: "Merci pour votre demande ! Nous vous recontacterons rapidement.",
    sending: "Envoi...",
    send: "Envoyer la demande",
    details: "Nos coordonnées",
    addressLabel: "Adresse",
    phoneLabel: "Téléphone",
    emailLabel: "E-mail",
    hoursLabel: "Horaires d'ouverture",
    sat: "Sam : Sur rendez-vous",
  },
  detail: {
    home: "Accueil",
    photos: "Photos",
    specifications: "Spécifications",
    make: "Marque",
    model: "Modèle",
    year: "Année",
    fitment: "Compatibilité",
    condition: "État",
    warranty: "Garantie",
    notFound: "Cette pièce est introuvable. Elle a peut-être été vendue ou retirée.",
    backHome: "Retour à l'accueil",
    backToList: "Retour à la liste",
  },
};